import { Link, useParams } from 'react-router-dom';
import Modal from '../../../../commons/Modal/Modal';
import { ModalProps } from '../../../../commons/Modal/Modal.types';
import Button from '../../../../designSystem/Button/Button';
import { getLoginUrlByRole } from '../../../../../utils/helpers/router/getLoginUrlByRole';
import { UserRoles } from '../../../../../types/models/user/user.types';

export default (props: ModalProps) => {
  const { role } = useParams();
  const loginUrl = getLoginUrlByRole(role as UserRoles);

  return (
    <Modal {...props}>
      <h2>Votre mot de passe a bien été pris en compte</h2>
      <p>Vous pouvez désormais vous identifier pour accéder à votre espace.</p>
      <Link to={loginUrl}>
        <Button>Me connecter</Button>
      </Link>
    </Modal>
  );
};
